<template>
  <div class="step">
      <ul class="nav nav-tabs nav-justified" role="tablist">
          <li role="step" :data-step="step.step" :class="[{'active': step.active}, step.stepClass]" v-for="step in steps">
              <a role="tab" data-toggle="tab" aria-controls="home" aria-expanded="true">
                  <div :class="stepIcon(step)"></div>
                  <div class="heading">
                      <div class="title">{{ step.title }}</div>
                      <div class="description">{{ step.description }}</div>
                  </div>
              </a>
          </li>
      </ul>
      <!-- Tab panes -->
      <div class="tab-content">
          <slot></slot>
      </div>
  </div>
</template>
<script>
export default {
  props: {
    steps: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    stepIcon(step) {
      return 'icon fa fa-' + step.icon;
    },
    addStep(step) {
      if (this.steps.indexOf(step) == -1)
        this.steps.push(step);
    }
  }
}
</script>
